module.exports = __webpack_public_path__ + "img/mallaciclonica.ddcf879b.jpg";